export default __webpack_public_path__ + "static/media/Retirement-Planner.da2467d5.png";